// Color themes for JSONTree - matching system light/dark modes
export const lightTheme = {
  scheme: 'light',
  base00: '#ffffff', // Background
  base01: '#f5f5f5',
  base02: '#e0e0e0',
  base03: '#999999', // Comments
  base04: '#666666',
  base05: '#333333',
  base06: '#1a1a1a',
  base07: '#000000', // Foreground
  base08: '#d73737', // Red - null, undefined
  base09: '#d78700', // Orange - numbers
  base0A: '#b58900', // Yellow
  base0B: '#50a14f', // Green - strings
  base0C: '#0184bc', // Cyan - regex
  base0D: '#4078f2', // Blue - functions, property names
  base0E: '#a626a4', // Purple - keywords
  base0F: '#986801', // Brown
}

export const darkTheme = {
  scheme: 'dark',
  base00: '#1e1e1e', // Background - matching page background
  base01: '#2d2d2d',
  base02: '#3d3d3d',
  base03: '#666666', // Comments
  base04: '#999999',
  base05: '#cccccc',
  base06: '#e0e0e0',
  base07: '#ffffff', // Foreground
  base08: '#f48771', // Red - null, undefined
  base09: '#fc9867', // Orange - numbers
  base0A: '#ffd866', // Yellow
  base0B: '#a9dc76', // Green - strings
  base0C: '#78dce8', // Cyan - regex
  base0D: '#7fc8f8', // Blue - functions, property names
  base0E: '#ab9df2', // Purple - keywords
  base0F: '#ff6188', // Brown
}
